// import './badge.scss';

export { default } from './Badge';
export { default as template } from './badge.tpl';
